module.exports = __webpack_public_path__ + "static/mtb-1-27dbad7c2c0ad1ebeb351f4b9f27b334.jpg";